import type { Requests } from "../common/request.common";
import type { AgentSettlementResponseTypes } from "../common/response.common";
import { post } from "./common";

export const agentSettlement = {
    record(data: typeof Requests.AgentSettlement.Record.Input) {
        return post<typeof data, AgentSettlementResponseTypes.Record>(
            `/agent-settlement/record`,
            data,
        );
    },
    createSettlement(data: typeof Requests.AgentSettlement.CreateSettlement.Input) {
        return post<typeof data>(`/agent-settlement/create-settlement`, data);
    },
};
